import React, { memo, useMemo } from 'react'
import { RowActionsMenu } from 'src/components/shared/grid/RowActionsMenu'
import { invoiceActionLabels } from 'src/constants/invoice/constants'
import { InvoiceActionVerb } from 'src/constants/invoice/enums'
import type { MenuActionItem } from 'src/interfaces/ui'

interface Props {
  verbs: InvoiceActionVerb[]
  dataTestId: string
  onSelect(verb: InvoiceActionVerb): void
}

// An overflow menu rather than a row of buttons: there are up to seven verbs, and a row of
// seven destructive-looking buttons in a grid cell is both unreadable and easy to misclick.
const InvoiceActionsMenuComponent = ({ verbs, dataTestId, onSelect }: Props) => {
  const items = useMemo<MenuActionItem[]>(() => {
    return verbs.map((verb) => {
      return {
        label: invoiceActionLabels[verb],
        onClick: () => {
          onSelect(verb)
        },
      }
    })
  }, [verbs, onSelect])

  return <RowActionsMenu items={items} ariaLabel="Invoice actions" dataTestId={dataTestId} />
}

export const InvoiceActionsMenu = memo(InvoiceActionsMenuComponent)
